<template>
  <v-dialog :value="value" width="1000" persistent>
    <v-card class="modal">
      <component
        :is="componentName"
        :modal="true"
        :id="id"
        :key="id"
        @add="
          (newId) => {
            $emit('add', newId);
          }
        "
        @update="
          (item) => {
            $emit('update', item);
          }
        "
        @close="$emit('input')"
      />
      <slot />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {
    DocumentBlock() {
      return import("../views/document-blocks/DocumentBlock.vue");
    },
  },
  props: ["componentName", "id", "value"],
};
</script>
